import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Paper, Skeleton, Stack, Tooltip, Typography } from '@mui/material'

import {
  COLOR_FULFILMENT_RATE,
  DRIVER_APP_FULFILMENT_CHART_HEIGHT,
  FULFILMENT_TREND_INFO,
} from 'components/reports/Metrics/constants/DriverAppFulfilment'
import { DriverAppFulfilmentTrendDto } from 'generated/graphql'

import { FulfilmentTrendChart } from './FulfilmentTrendChart'

interface Props {
  data?: DriverAppFulfilmentTrendDto | null
  loading?: boolean
}

export const FulfilmentTrendCard = ({ data, loading }: Props) => (
  <Paper
    variant='outlined'
    sx={{ p: 2.5, borderRadius: 2, borderTop: `3px solid ${COLOR_FULFILMENT_RATE}` }}>
    <Box mb={2}>
      <Stack direction='row' spacing={1} alignItems='center'>
        <Typography variant='subtitle1' fontWeight={700}>
          Driver App fulfilment rate over time
        </Typography>
        <Tooltip title={FULFILMENT_TREND_INFO}>
          <InfoOutlinedIcon fontSize='small' sx={{ color: 'text.disabled' }} />
        </Tooltip>
      </Stack>
      <Typography variant='body2' color='primary.main'>
        Percentage of jobs fulfilled through Driver App.
      </Typography>
    </Box>

    {loading ? (
      <Skeleton
        variant='rectangular'
        height={DRIVER_APP_FULFILMENT_CHART_HEIGHT}
        sx={{ borderRadius: 1 }}
      />
    ) : (
      <FulfilmentTrendChart points={data?.points ?? []} />
    )}
  </Paper>
)
